'use client';

import { Box } from '@terra/ui-styled-system';
import { createContext, useContext, type ReactNode } from 'react';

const SettingsContentPanelActiveContext = createContext(true);

export function useIsSettingsContentPanelActive() {
  return useContext(SettingsContentPanelActiveContext);
}

export type SettingsContentPanelProps = {
  value: string;
  activeValue: string;
  children: ReactNode;
  keepMounted?: boolean;
  fillHeight?: boolean;
};

export function SettingsContentPanel({
  value,
  activeValue,
  children,
  keepMounted,
  fillHeight,
}: SettingsContentPanelProps) {
  const isActive = value === activeValue;

  if (!keepMounted && !isActive) {
    return null;
  }

  if (fillHeight) {
    return (
      <SettingsContentPanelActiveContext.Provider value={isActive}>
        <Box
          display={isActive ? 'flex' : 'none'}
          flexDirection="column"
          flex="1"
          minH={0}
          h="full"
          w="full"
          overflow="hidden"
        >
          {children}
        </Box>
      </SettingsContentPanelActiveContext.Provider>
    );
  }

  return (
    <SettingsContentPanelActiveContext.Provider value={isActive}>
      <Box display={isActive ? 'block' : 'none'} w="full">
        {children}
      </Box>
    </SettingsContentPanelActiveContext.Provider>
  );
}
